/**
 * Sticky Header - Only Cookies USA
 *
 * Uses IntersectionObserver to toggle between transparent and solid header
 * states based on scroll position.
 *
 * On homepage with transparent header enabled:
 *   - Starts transparent (overlaying hero)
 *   - Becomes solid once user scrolls past the sentinel element
 *
 * On all other pages (or if transparent is disabled):
 *   - Always solid
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var isTransparent = header.getAttribute('data-transparent') === 'true';
  var isSticky = header.getAttribute('data-sticky') === 'true';
  var sentinel = document.getElementById('HeaderSentinel');

  /* If header is not sticky and not transparent, nothing to observe */
  if (!isSticky && !isTransparent) return;

  /**
   * For non-transparent headers (other pages), apply scrolled class immediately
   * based on scroll position, or always show solid.
   */
  if (!isTransparent) {
    header.classList.add('site-header--scrolled');
    return;
  }

  /**
   * For transparent headers on homepage, use IntersectionObserver
   * to detect when the sentinel exits the viewport.
   */
  if (!sentinel) {
    /* No sentinel found, fall back to solid */
    header.classList.add('site-header--scrolled');
    return;
  }

  /* Ensure the sentinel has the correct height for transparent mode */
  /* (transparent sentinel has height: 0, so we create a virtual threshold) */

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            /* Sentinel is visible = we're at the top */
            header.classList.remove('site-header--scrolled');
          } else {
            /* Sentinel not visible = we've scrolled past */
            header.classList.add('site-header--scrolled');
          }
        });
      },
      {
        /* Trigger as soon as the sentinel leaves viewport */
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      }
    );

    /*
     * For transparent mode, the sentinel has height: 0.
     * We observe a different target: the hero section or the top of main content.
     * Create a small sentinel div at the very top of the page to watch.
     */
    var observeTarget = document.createElement('div');
    observeTarget.setAttribute('aria-hidden', 'true');
    observeTarget.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:100px;pointer-events:none;visibility:hidden;';
    document.body.insertBefore(observeTarget, document.body.firstChild);

    observer.observe(observeTarget);
  } else {
    /**
     * Fallback for browsers without IntersectionObserver.
     * Simple scroll listener with passive flag.
     */
    var scrollThreshold = 80;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > scrollThreshold) {
            header.classList.add('site-header--scrolled');
          } else {
            header.classList.remove('site-header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    /* Run once on load */
    onScroll();
  }
})();
